import BrandTypes from 'constants/brand';
import type { MarketingCardBffData, MarketingCardBffState } from '../../store';
import {
  PLANS_ALWAYS_ON_CONTENT_KEYS,
  PLANS_ALWAYS_ON_DELIVERY_KEYS,
  TEMPLATE1_SMART_OFFER_DELIVERY_KEY_PREFIX,
} from './plansAlwaysOnContentConstants';

export const resolveIsPlanAlwaysOnDisplayed = (data: MarketingCardBffData | null): boolean => {
  if (data === null) {
    return false;
  }

  const { deliveryKeyId2 } = data.fs;
  const { content } = data.cms;

  return !!(
    deliveryKeyId2 && content[PLANS_ALWAYS_ON_DELIVERY_KEYS.primary]?.[PLANS_ALWAYS_ON_CONTENT_KEYS.monthlyPricing]
  );
};

export const isTemplate1SmartOffer = (data: MarketingCardBffData | null): boolean => {
  if (data === null) {
    return false;
  }

  if (data.cms.templateId === '1') {
    return true;
  }

  return data.fs.deliveryKeyId.startsWith(TEMPLATE1_SMART_OFFER_DELIVERY_KEY_PREFIX);
};

export const shouldSuppressSmartOfferForDisplayedPlanAlwaysOn = ({
  showPlansAlwaysOn,
  marketingCardBffData,
  marketingCardBffState,
}: {
  showPlansAlwaysOn: boolean;
  marketingCardBffData: MarketingCardBffData | null;
  marketingCardBffState: MarketingCardBffState;
}): boolean => {
  if (!showPlansAlwaysOn) {
    return false;
  }

  if (marketingCardBffState !== 'success') {
    return false;
  }

  if (!resolveIsPlanAlwaysOnDisplayed(marketingCardBffData)) {
    return false;
  }

  return isTemplate1SmartOffer(marketingCardBffData);
};

export const shouldShowSmartOfferBox = (params: {
  site: string;
  showPlansAlwaysOn: boolean;
  marketingCardBffData: MarketingCardBffData | null;
  marketingCardBffState: MarketingCardBffState;
}): boolean =>
  params.site === BrandTypes.VERY &&
  !shouldSuppressSmartOfferForDisplayedPlanAlwaysOn({
    showPlansAlwaysOn: params.showPlansAlwaysOn,
    marketingCardBffData: params.marketingCardBffData,
    marketingCardBffState: params.marketingCardBffState,
  });
